/**
 * Debounce functions for better performance
 * (c) 2021 Chris Ferdinandi, MIT License, https://gomakethings.com
 * @param  {Function} fn The function to debounce
 */
const addHeaderSpacing = val => {
  const body = document.querySelector('body');
  if (!body) {
    return;
  }
  const header = body.querySelector('.section__header');
  if (!header) {
    return;
  }
  const shopifyHeader = body.querySelector('#shopify-section-header');
  if (!shopifyHeader) {
    return;
  }
  let headerHeight = header.offsetHeight;
  // let headerHeight = header.clientHeight;

  if (val === 0) {
    headerHeight = 0;
  }
  shopifyHeader.height = headerHeight + 'px';
};
var lastScrollTop = 0;
// removed debounce as it prevented us from detecting if we are going up or down
// const handleScroll = debounce((ev) => {
const handleScroll = ev => {
  var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
  [...document.querySelectorAll('[data-affix]')].forEach(affixedElem => {
    let stickyStartsAt = 0;
    if (affixedElem.dataset.affixAt) {
      stickyStartsAt = affixedElem.dataset.affixAt;
    }

    // on pdp, we do something different body.template__product
    const body = document.querySelector('body');
    if (!body) {
      return;
    }
    if (body.classList.contains('template__product')) {
      if (scrollTop > lastScrollTop) {
        // downscroll code
        affixedElem.classList.remove('is-sticky');
        body.classList.remove('has-sticky-header');
        addHeaderSpacing(0);
      } else if (scrollTop < lastScrollTop) {
        // upscroll code
        if (scrollTop <= stickyStartsAt) {
          affixedElem.classList.remove('is-sticky');
          body.classList.remove('has-sticky-header');
          addHeaderSpacing(0);
        } else {
          affixedElem.classList.add('is-sticky');
          body.classList.add('has-sticky-header');
          addHeaderSpacing(1);
        }
      }
      // else was horizontal scroll
    } else {
      if (!stickyStartsAt) {
        return;
      }
      if (scrollTop > stickyStartsAt) {
        affixedElem.classList.add('is-sticky');
        body.classList.add('has-sticky-header');
        addHeaderSpacing(1);
      } else {
        affixedElem.classList.remove('is-sticky');
        body.classList.remove('has-sticky-header');
        addHeaderSpacing(0);
      }
    }
    lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
  });
};
// }, 250);

window.addEventListener('scroll', handleScroll, false);
